module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/17-62a64f2edd8b63e52181353d52beafa4.jpg";